import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

const OurWorkDetail = () => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);
  var settings = { 
     
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          vertical: false,
          rtl: false,
          verticalSwiping: false,
          swipeToSlide: true,
          
        },
      },
    ],
  };
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <>
        <div className={className} style={{ ...style }} onClick={onClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M8.41394 13.7471L17.9999 13.7471L17.9999 11.7471L8.41394 11.7471L12.7069 7.4541L11.2929 6.0401L4.58594 12.7471L11.2929 19.4541L12.7069 18.0401L8.41394 13.7471Z"
              fill="black"
            />
          </svg>
        </div>
      </>
    );
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <>
        <div className={className} style={{ ...style }} onClick={onClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M15.5861 11.747L6.00006 11.747L6.00006 13.747L15.5861 13.747L11.2931 18.04L12.7071 19.454L19.4141 12.747L12.7071 6.04004L11.2931 7.45404L15.5861 11.747Z"
              fill="black"
            />
          </svg>
        </div>
      </>
    );
  }
  var settings2 = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ] 
  };

  return (
    <>
      <div className="portfolio_craft">
        <div className="wrapper">
          <div className="title title_head">
             
            <h1 data-aos="zoom-out-up">
            What 
              <span>We’ve Done</span>
            </h1>
            <p>Crafting Success Together: A 360° Journey Across Diverse Industries</p>
            {/* <a href="javascript:void(0)" className="let_start"><span>Let’s Start</span></a> */}
          </div>
          <div className="portcompany_slider">
            <Slider
              asNavFor={nav2}
              ref={(slider) => (sliderRef1 = slider)}
              slidesToShow={5}
              {...settings2}
            >
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i14.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_177_74)">
    <path d="M17.3999 9.6001H0.600073C0.268726 9.6001 0 9.8686 0 10.2V23.4C0 23.7314 0.268726 24.0001 0.600073 24.0001H4.79993V16.2C4.79993 15.8687 5.06865 15.6 5.4 15.6H12.6C12.9313 15.6 13.2001 15.8687 13.2001 16.2V24.0001H18V10.2C18 9.8686 17.7313 9.6001 17.3999 9.6001Z" fill="white"/>
    <path d="M6 16.8003H11.9999V24.0003H6V16.8003Z" fill="white"/>
    <path d="M23.4003 13.1997H19.2002V23.9997H23.4003C23.5594 23.9997 23.7121 23.9366 23.8246 23.8239C23.9373 23.7114 24.0003 23.5587 24.0003 23.3996V13.7996C24.0003 13.6405 23.9373 13.4878 23.8246 13.3753C23.7121 13.2628 23.5594 13.1995 23.4003 13.1997ZM22.2003 19.1996H21.0002C20.6688 19.1996 20.4003 18.9311 20.4003 18.5997C20.4003 18.2684 20.6688 17.9996 21.0002 17.9996H22.2003C22.5317 17.9996 22.8002 18.2684 22.8002 18.5997C22.8002 18.9311 22.5317 19.1996 22.2003 19.1996ZM22.2003 16.7997H21.0002C20.6688 16.7997 20.4003 16.531 20.4003 16.1996C20.4003 15.8683 20.6688 15.5996 21.0002 15.5996H22.2003C22.5317 15.5996 22.8002 15.8683 22.8002 16.1996C22.8002 16.531 22.5317 16.7997 22.2003 16.7997Z" fill="white"/>
    <path d="M13.2007 2.99993C13.3597 3.00015 13.5125 2.93686 13.625 2.82436C13.7375 2.71186 13.8007 2.55915 13.8005 2.40007C13.8005 2.26802 13.8005 2.23242 14.2905 2.06895C14.7486 1.91667 15.6005 1.63235 15.6005 0.600073C15.6005 0.268726 15.332 0 15.0007 0C14.6693 0 14.4006 0.268726 14.4006 0.600073C14.4006 0.731909 14.4006 0.767505 13.9108 0.930981C13.4527 1.08347 12.6006 1.36758 12.6006 2.40007C12.6006 2.55915 12.6636 2.71186 12.7761 2.82436C12.8889 2.93686 13.0414 3.00015 13.2007 2.99993Z" fill="white"/>
    <path d="M15.6005 4.20036C15.6007 3.97888 15.479 3.77541 15.2839 3.67104C15.0888 3.56667 14.8519 3.57809 14.6678 3.70114L12.8678 4.90107C12.701 5.01247 12.6008 5.19968 12.6006 5.40029V8.40021H15.6005V4.20036Z" fill="white"/>
    <path d="M8.10007 2.99993C8.25916 3.00015 8.41187 2.93686 8.52437 2.82436C8.63708 2.71186 8.70015 2.55915 8.70015 2.40007C8.70015 2.26802 8.70015 2.23242 9.18992 2.06895C9.64805 1.91667 10.5001 1.63235 10.5001 0.600073C10.5001 0.268726 10.2314 0 9.90007 0C9.56873 0 9.3 0.268726 9.3 0.600073C9.3 0.731909 9.3 0.767505 8.81023 0.930981C8.3521 1.08347 7.5 1.36758 7.5 2.40007C7.5 2.55915 7.56306 2.71186 7.67578 2.82436C7.78828 2.93686 7.94099 3.00015 8.10007 2.99993Z" fill="white"/>
    <path d="M10.5001 4.19987C10.5004 3.97839 10.3784 3.77492 10.1833 3.67055C9.98818 3.56618 9.75132 3.57761 9.56719 3.70065L7.76719 4.90058C7.60063 5.01198 7.50044 5.19919 7.5 5.3998V8.39972H10.5001V4.19987Z" fill="white"/>
    <path d="M3.00122 2.99993C3.16052 3.00015 3.31301 2.93686 3.42573 2.82436C3.53823 2.71186 3.60129 2.55915 3.60129 2.40007C3.60129 2.26802 3.60129 2.23242 4.09106 2.06895C4.54919 1.91667 5.40129 1.63235 5.40129 0.600073C5.40129 0.268726 5.13257 0 4.80122 0C4.46987 0 4.20137 0.268726 4.20137 0.600073C4.20137 0.731909 4.20137 0.767505 3.71138 0.930981C3.25325 1.08347 2.40137 1.36758 2.40137 2.40007C2.40115 2.55915 2.46443 2.71186 2.57693 2.82436C2.68943 2.93686 2.84214 3.00015 3.00122 2.99993Z" fill="white"/>
    <path d="M5.40129 4.20036C5.40151 3.97888 5.27979 3.77541 5.08445 3.67104C4.88933 3.56667 4.65247 3.57809 4.46855 3.70114L2.66855 4.90107C2.50178 5.01247 2.40159 5.19968 2.40137 5.40029V8.40021H5.40129V4.20036Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_177_74">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Manufacturing</p>
                  </div>
                </div>
              </div>
              
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i3.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M23.5308 6.01663L12.234 2.0308C12.0826 1.97736 11.9175 1.97736 11.7661 2.0308L0.469219 6.01663C0.188344 6.11572 0.000375562 6.38103 5.61892e-07 6.67888C-0.000374438 6.97672 0.186985 7.24246 0.467626 7.34221L11.7645 11.3583C11.8407 11.3854 11.9204 11.399 12 11.399C12.0797 11.399 12.1593 11.3854 12.2355 11.3583L23.5324 7.34221C23.813 7.24246 24.0003 6.97672 24 6.67888C23.9996 6.38103 23.8117 6.11572 23.5308 6.01663Z" fill="white"/>
  <path d="M22.3105 15.4017V9.26855L20.9043 9.76848V15.4017C20.4807 15.6455 20.1953 16.1023 20.1953 16.6261C20.1953 17.1499 20.4807 17.6067 20.9043 17.8505V21.306C20.9043 21.6943 21.2191 22.0091 21.6074 22.0091C21.9957 22.0091 22.3105 21.6943 22.3105 21.306V17.8506C22.7341 17.6068 23.0195 17.1499 23.0195 16.6261C23.0195 16.1023 22.7342 15.6455 22.3105 15.4017Z" fill="white"/>
  <path d="M11.9997 12.8049C11.7583 12.8049 11.5206 12.7639 11.2931 12.683L4.94238 10.4253V13.5194C4.94238 14.2764 5.73209 14.9166 7.28955 15.4221C8.6471 15.8627 10.3199 16.1054 11.9997 16.1054C13.6795 16.1054 15.3522 15.8627 16.7098 15.4221C18.2673 14.9166 19.057 14.2764 19.057 13.5194V10.4253L12.7063 12.683C12.4788 12.7639 12.2411 12.8049 11.9997 12.8049Z" fill="white"/>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Education</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i2.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <path d="M11.9932 3.60881C6.7619 -0.966684 0.110422 3.05348 0.00135253 8.50345C-0.0264422 9.89239 0.374496 11.2453 1.17258 12.4926H6.34549L7.26558 10.9591C7.53275 10.5139 8.17929 10.4995 8.4616 10.9434L10.4029 13.9939L13.2326 8.02011C13.4794 7.49886 14.2149 7.48231 14.4871 7.98777L16.9128 12.4926H22.8138C27.1851 5.66065 18.5459 -2.12239 11.9932 3.60881Z" fill="white"/>
  <path d="M15.8742 13.5293L13.9086 9.87891L11.129 15.7467C10.8926 16.246 10.1971 16.2893 9.9005 15.8232L7.88643 12.6583L7.3468 13.5577C7.21973 13.7695 6.99091 13.899 6.74394 13.899H2.28516C2.42493 14.0453 1.68 13.3019 11.4976 23.0687C11.7718 23.3415 12.2151 23.3416 12.4893 23.0687C22.1559 13.4521 21.5623 14.045 21.7018 13.899H16.4932C16.2345 13.8991 15.9968 13.757 15.8742 13.5293Z" fill="white"/>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Healthcare</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i4.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_886)">
    <path d="M5.35352 17.2617C5.35352 16.8975 5.05853 16.6025 4.69434 16.6025H1.39844C1.03424 16.6025 0.739258 16.8975 0.739258 17.2617V22.5791C0.739258 22.9433 1.03424 23.2383 1.39844 23.2383H4.69434C5.05853 23.2383 5.35352 22.9433 5.35352 22.5791V17.2617Z" fill="white"/>
    <path d="M10.6709 12.6475H7.375C7.0108 12.6475 6.71582 12.9424 6.71582 13.3066V22.5791C6.71582 22.9433 7.0108 23.2383 7.375 23.2383H10.6709C11.0351 23.2383 11.3301 22.9433 11.3301 22.5791V13.3066C11.3301 12.9424 11.0351 12.6475 10.6709 12.6475Z" fill="white"/>
    <path d="M16.6035 11.3291H13.3076C12.9434 11.3291 12.6484 11.6241 12.6484 11.9883V22.5791C12.6484 22.9433 12.9434 23.2383 13.3076 23.2383H16.6035C16.9677 23.2383 17.2627 22.9433 17.2627 22.5791V11.9883C17.2627 11.6241 16.9677 11.3291 16.6035 11.3291Z" fill="white"/>
    <path d="M22.5801 6.05566H19.2842C18.92 6.05566 18.625 6.35065 18.625 6.71484V22.5791C18.625 22.9433 18.92 23.2383 19.2842 23.2383H22.5801C22.9443 23.2383 23.2393 22.9433 23.2393 22.5791V6.71484C23.2393 6.35065 22.9443 6.05566 22.5801 6.05566Z" fill="white"/>
    <path d="M3.0918 15.2402C4.18219 15.2402 5.06934 14.3531 5.06934 13.2627C5.06934 13.0774 5.03555 12.9018 4.98776 12.7318L7.55609 10.9188C7.87854 11.1477 8.2702 11.2852 8.69482 11.2852C9.69527 11.2852 10.5157 10.5359 10.6457 9.57047L13.2756 9.01675C13.6237 9.5842 14.2442 9.9668 14.957 9.9668C16.0474 9.9668 16.9346 9.07965 16.9346 7.98926C16.9346 7.72559 16.8805 7.47482 16.7865 7.24466L19.9414 4.4404C20.2243 4.59654 20.5443 4.69336 20.8896 4.69336C21.98 4.69336 22.8672 3.80621 22.8672 2.71582C22.8672 1.62543 21.98 0.738281 20.8896 0.738281C19.7993 0.738281 18.9121 1.62543 18.9121 2.71582C18.9121 2.97949 18.9662 3.23026 19.0602 3.46042L15.9053 6.26468C15.6224 6.10854 15.3024 6.01172 14.957 6.01172C13.9566 6.01172 13.1362 6.76099 13.0061 7.72641L10.3763 8.28012C10.0282 7.71268 9.4077 7.33008 8.69482 7.33008C7.60443 7.33008 6.71729 8.21722 6.71729 9.30762C6.71729 9.49287 6.75107 9.66852 6.79886 9.83853L4.23053 11.6516C3.90808 11.4226 3.51642 11.2852 3.0918 11.2852C2.0014 11.2852 1.11426 12.1723 1.11426 13.2627C1.11426 14.3531 2.0014 15.2402 3.0918 15.2402Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_886">
      <rect width="24" height="24" fill="white" transform="translate(0.00195312)"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Finance & FinTech</p>
                  </div>
                </div>
              </div>

              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i5.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1819)">
    <path d="M21.1852 0H2.81484C1.26281 0 0 1.26281 0 2.81484V5.625H24V2.81484C24 1.26281 22.7372 0 21.1852 0ZM3.04688 3.51562C2.65875 3.51562 2.34375 3.20062 2.34375 2.8125C2.34375 2.42438 2.65875 2.10938 3.04688 2.10938C3.435 2.10938 3.75 2.42438 3.75 2.8125C3.75 3.20062 3.435 3.51562 3.04688 3.51562ZM5.85938 3.51562C5.47125 3.51562 5.15625 3.20062 5.15625 2.8125C5.15625 2.42438 5.47125 2.10938 5.85938 2.10938C6.2475 2.10938 6.5625 2.42438 6.5625 2.8125C6.5625 3.20062 6.2475 3.51562 5.85938 3.51562ZM20.9531 3.51562H9.60938C9.22125 3.51562 8.90625 3.20062 8.90625 2.8125C8.90625 2.42438 9.22125 2.10938 9.60938 2.10938H20.9531C21.3412 2.10938 21.6562 2.42438 21.6562 2.8125C21.6562 3.20062 21.3412 3.51562 20.9531 3.51562Z" fill="white"/>
    <path d="M9.60645 20.4844C9.99477 20.4844 10.3096 20.1696 10.3096 19.7812C10.3096 19.3929 9.99477 19.0781 9.60645 19.0781C9.21812 19.0781 8.90332 19.3929 8.90332 19.7812C8.90332 20.1696 9.21812 20.4844 9.60645 20.4844Z" fill="white"/>
    <path d="M16.2158 20.4844C16.6041 20.4844 16.9189 20.1696 16.9189 19.7812C16.9189 19.3929 16.6041 19.0781 16.2158 19.0781C15.8275 19.0781 15.5127 19.3929 15.5127 19.7812C15.5127 20.1696 15.8275 20.4844 16.2158 20.4844Z" fill="white"/>
    <path d="M17.3191 13.4021C17.5094 13.6623 17.5623 13.988 17.4644 14.2951L16.3867 17.671H9.17266L8.30641 14.0949V14.093L8.04297 12.9919H16.5123C16.8348 12.9919 17.1287 13.1415 17.3191 13.4021Z" fill="white"/>
    <path d="M0 7.03125V21.1852C0 22.7372 1.26281 24 2.81484 24H21.1852C22.7372 24 24 22.7372 24 21.1852V7.03125H0ZM18.8039 14.723L17.6747 18.2606C18.075 18.6445 18.3248 19.1841 18.3248 19.7812C18.3248 20.9442 17.3784 21.8906 16.2155 21.8906C15.0525 21.8906 14.1061 20.9442 14.1061 19.7812C14.1061 19.5342 14.1492 19.2975 14.2275 19.0772H11.5941C11.6723 19.2975 11.7155 19.5342 11.7155 19.7812C11.7155 20.9442 10.7691 21.8906 9.60609 21.8906C8.44312 21.8906 7.49672 20.9442 7.49672 19.7812C7.49672 19.3017 7.6575 18.8597 7.92797 18.5048L6.01219 10.5469H3.90891C3.52031 10.5469 3.20578 10.2319 3.20578 9.84375C3.20578 9.45563 3.52031 9.14062 3.90891 9.14062H6.56719C6.88505 9.13758 7.17998 9.37041 7.25109 9.68016L7.70672 11.5856H16.5127C17.2889 11.5856 17.9972 11.9452 18.4552 12.5723C18.9131 13.1991 19.0402 13.9833 18.8039 14.723Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1819">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Retail & E-Commerce</p>
                  </div>
                </div>
              </div>

              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i12.png" alt="" /> */}<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1634)">
    <path d="M24 11.5949C24 17.1067 19.9345 21.6868 14.6447 22.4944C14.6893 22.2497 14.7018 21.9964 14.6718 21.7397C14.6718 21.7397 14.6402 21.4696 14.5989 21.1161C16.4769 20.7961 18.1725 19.9343 19.5165 18.695C19.4358 18.6279 19.3555 18.5409 19.2763 18.4253C18.9193 17.9045 19.3861 17.3877 19.3861 16.9323C19.3861 16.4855 18.4854 16.5223 18.4524 16.2264C18.3386 15.2017 19.0813 15.1877 19.4772 14.7918C19.8731 14.3959 19.0858 13.4958 18.5773 13.5539C18.0654 13.6085 16.6243 13.3174 16.756 12.2149C16.9164 10.872 15.0451 10.9905 14.7772 10.3637C14.3865 9.45009 15.0359 8.32947 15.8829 8.07488C17.0826 7.71429 18.2644 6.73558 18.1721 5.64609C18.0675 4.41217 17.509 3.29935 16.5891 2.63829C15.6319 2.25049 14.5997 2.01068 13.5198 1.95017C12.556 1.98829 11.7086 2.20249 11.7473 2.64374C11.842 3.72507 14.917 4.00594 14.401 5.01676C14.132 5.5437 12.113 6.28743 12.49 7.07166C12.7353 7.58166 13.3389 7.14456 13.1135 8.12366C13.0098 8.57417 12.6148 9.42064 12.0073 9.47527C11.3861 9.53327 10.8688 7.88755 9.17792 7.83358C8.37855 7.80802 7.25239 9.0808 8.20862 9.98378C8.78768 10.5306 9.87431 9.32656 10.195 10.2671C10.421 10.9299 10.1646 12.3222 11.2194 12.9041C11.6039 13.1162 12.1933 13.3011 12.7763 13.5973C11.911 13.7741 10.8478 14.1038 9.59231 14.5874L8.53451 14.3083C8.97733 13.9397 9.69682 13.6802 9.5158 12.8747C9.24988 11.6913 7.1951 12.1376 5.77851 10.721C5.34392 10.2865 4.41698 8.84366 4.42078 7.11017C3.71466 8.45143 3.31278 9.97676 3.31278 11.5949C3.31278 12.093 3.35078 12.5824 3.42384 13.0604C3.40717 13.0601 3.3907 13.0572 3.37408 13.0572C2.92796 13.0572 2.49043 13.151 2.08494 13.3282C1.99537 12.7633 1.94757 12.1847 1.94757 11.595C1.94757 5.51515 6.89396 0.568604 12.9737 0.568604C19.0536 0.568525 24 5.51507 24 11.5949ZM15.729 14.8087L13.036 16.0465L13.0778 15.4597L14.8223 14.6722C14.5735 14.6544 14.3157 14.6476 14.0583 14.6476C13.0944 14.6476 11.4659 15.1355 9.66474 15.8505L3.888 14.3268C3.34815 14.1843 2.77341 14.2721 2.30059 14.5691L2.01655 14.7475C1.73925 14.9217 1.73631 15.3249 2.01102 15.5032L5.48353 17.756C4.654 18.1803 3.86698 18.6111 3.17317 19.0226L1.39129 18.0792C1.10023 17.9252 0.756115 17.9069 0.450429 18.0293L0.281762 18.0969C0.0302329 18.1976 -0.0751397 18.4967 0.0578015 18.7328L1.03941 20.4768L1.03984 20.4767C0.669488 20.7953 0.458429 21.0595 0.458429 21.2424C0.458429 21.7897 1.13192 21.9265 1.72557 21.9265C2.78439 21.9265 16.7674 18.7249 16.7674 15.8243C16.7673 15.2499 16.3745 14.9626 15.729 14.8087ZM9.83337 20.4718L12.9103 19.3879C13.0459 19.3401 13.1907 19.4304 13.2074 19.5732L13.4772 21.8797C13.5446 22.456 13.2346 23.0106 12.7084 23.2553L12.4198 23.3894C12.2396 23.4732 12.0258 23.4283 11.8944 23.2791L9.7396 20.8313C9.6347 20.7121 9.68357 20.5246 9.83337 20.4718Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1634">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Tours & Travels</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i7.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1858)">
    <path d="M4.21875 19.7812H19.7812V9.9375H4.21875V19.7812ZM9.89062 12.0469C9.89062 11.7873 10.0335 11.5491 10.2621 11.4268C10.4908 11.3046 10.7675 11.3176 10.9838 11.4618L15.2025 14.2743C15.3983 14.4048 15.5157 14.6245 15.5157 14.8593C15.5157 15.0941 15.3983 15.3139 15.2025 15.4443L10.9838 18.2568C10.7658 18.4022 10.4876 18.4128 10.2621 18.2918C10.0335 18.1697 9.89062 17.9314 9.89062 17.6719V12.0469Z" fill="white"/>
    <path d="M11.2969 13.3604V16.3583L13.545 14.8593L11.2969 13.3604Z" fill="white"/>
    <path d="M21.8906 5.71875H2.10938C0.946219 5.71875 0 6.66497 0 7.82812V21.8906C0 23.0538 0.946219 24 2.10938 24H21.8906C23.0538 24 24 23.0538 24 21.8906V7.82812C24 6.66497 23.0538 5.71875 21.8906 5.71875ZM21.1875 20.4844C21.1875 20.873 20.873 21.1875 20.4844 21.1875H3.51562C3.12698 21.1875 2.8125 20.873 2.8125 20.4844V9.23438C2.8125 8.84573 3.12698 8.53125 3.51562 8.53125H20.4844C20.873 8.53125 21.1875 8.84573 21.1875 9.23438V20.4844Z" fill="white"/>
    <path d="M17.128 0.206021L13.1152 4.21876H15.1038L18.1223 1.20024C18.3969 0.9256 18.3969 0.480615 18.1223 0.205975C17.8476 -0.068666 17.4027 -0.068666 17.128 0.206021Z" fill="white"/>
    <path d="M5.87786 0.206016C5.60321 0.480656 5.60321 0.925641 5.87786 1.20028L8.89632 4.21875H10.8849L6.87207 0.206016C6.59743 -0.0686719 6.1525 -0.0686719 5.87786 0.206016Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1858">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Media & Entertainment</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i8.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1671)">
    <path d="M21.5892 22.5934V5.34652H19.3557V22.5934H17.9491V0L6.04755 3.33694V8.11719H11.1316V22.5934H9.72494V9.52383H3.81736V22.5934H0.933594V24H23.0664V22.5934H21.5892ZM13.8062 14.5746V11.7453H15.2129V14.5746H13.8062ZM15.2129 16.9125V19.7418H13.8062V16.9125H15.2129ZM13.8062 9.40741V6.57813H15.2129V9.40741H13.8062ZM6.0678 11.7453H7.47445V14.5746H6.0678V11.7453ZM6.0678 16.9125H7.47445V19.7418H6.0678V16.9125Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1671">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>  
                  </div>
                  <div className="com_name">
                    <p>Real Estate</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i9.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_177_121)">
    <path d="M16.6875 22.5938H14.8823L14.6308 21.5625H9.36923L9.1177 22.5938H7.3125C6.92419 22.5938 6.60938 22.9086 6.60938 23.2969C6.60938 23.6852 6.92419 24 7.3125 24H16.6875C17.0758 24 17.3906 23.6852 17.3906 23.2969C17.3906 22.9086 17.0758 22.5938 16.6875 22.5938Z" fill="white"/>
    <path d="M6.91406 15H11.2973V11.25H7.38281L6.91406 15Z" fill="white"/>
    <path d="M11.2973 16.4062H6.73828L6.26953 20.1562H11.2973V16.4062Z" fill="white"/>
    <path d="M12.7031 16.4062V20.1562H17.7309L17.2621 16.4062H12.7031Z" fill="white"/>
    <path d="M12.7031 15H17.0864L16.6176 11.25H12.7031V15Z" fill="white"/>
    <path d="M22.104 11.7826C22.0258 11.4696 21.7446 11.25 21.4219 11.25H18.0352L18.5039 15H22.9084L22.104 11.7826Z" fill="white"/>
    <path d="M23.9791 19.2826L23.26 16.4062H18.6797L19.1484 20.1562H23.2969C23.7544 20.1562 24.09 19.7264 23.9791 19.2826Z" fill="white"/>
    <path d="M0.0213418 19.2826C-0.0896113 19.7264 0.246061 20.1562 0.703467 20.1562H4.85195L5.3207 16.4062H0.740451L0.0213418 19.2826Z" fill="white"/>
    <path d="M1.8971 11.7826L1.09277 15H5.49729L5.96604 11.25H2.57923C2.25659 11.25 1.97538 11.4696 1.8971 11.7826Z" fill="white"/>
    <path d="M7.69073 8.84541C7.77216 9.15722 8.05242 9.375 8.3723 9.375H15.6277C15.9475 9.375 16.2278 9.15722 16.3092 8.84545C16.4047 8.48011 16.4531 8.10628 16.4531 7.73438C16.4531 5.27892 14.4555 3.28125 12 3.28125C9.54455 3.28125 7.54688 5.27892 7.54688 7.73438C7.54688 8.10628 7.5953 8.48011 7.69073 8.84541Z" fill="white"/>
    <path d="M19.0311 8.4375C19.4194 8.4375 19.7342 8.12269 19.7342 7.73438C19.7342 7.34606 19.4194 7.03125 19.0311 7.03125H17.8169C17.8446 7.26188 17.8592 7.49644 17.8592 7.73438C17.8592 7.96884 17.8443 8.20369 17.8154 8.4375H19.0311Z" fill="white"/>
    <path d="M6.18295 7.03125H4.96875C4.58044 7.03125 4.26562 7.34606 4.26562 7.73438C4.26562 8.12269 4.58044 8.4375 4.96875 8.4375H6.18441C6.15558 8.20373 6.14062 7.96889 6.14062 7.73438C6.14062 7.49644 6.15525 7.26188 6.18295 7.03125Z" fill="white"/>
    <path d="M12.7031 1.91733V0.703125C12.7031 0.314812 12.3883 0 12 0C11.6117 0 11.2969 0.314812 11.2969 0.703125V1.91733C11.5275 1.88962 11.7621 1.875 12 1.875C12.2379 1.875 12.4725 1.88962 12.7031 1.91733Z" fill="white"/>
    <path d="M16.6096 4.12017L17.4699 3.25988C17.7445 2.98528 17.7445 2.54011 17.4699 2.26552C17.1953 1.99092 16.7501 1.99092 16.4755 2.26552L15.6152 3.12581C15.985 3.41639 16.319 3.75047 16.6096 4.12017Z" fill="white"/>
    <path d="M7.39144 4.11993C7.68202 3.75018 8.01609 3.41615 8.3858 3.12557L7.5255 2.26527C7.25091 1.99068 6.80573 1.99068 6.53114 2.26527C6.25655 2.53987 6.25655 2.98504 6.53114 3.25963L7.39144 4.11993Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_177_121">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Energy & Utilities</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i10.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1648)">
    <path d="M8.18099 13.2802C8.42521 13.2802 8.63568 13.2703 8.79881 13.2586L11.2972 15.7566V17.5575H12.7035V15.7566L15.2019 13.2586C15.3651 13.2703 15.5755 13.2802 15.8197 13.2802C16.9176 13.2802 18.6927 13.0758 19.8618 11.9072C21.6205 10.1484 21.1958 7.01766 21.1766 6.88547C21.1326 6.57609 20.8897 6.33328 20.5804 6.28875C20.4482 6.27 17.3174 5.84531 15.5587 7.60406C14.1299 9.03281 14.1426 11.3681 14.2072 12.2639L12.7035 13.7681V8.98922C13.3832 8.40141 15.043 6.75937 15.043 4.73859C15.043 2.25141 12.5291 0.337969 12.4222 0.257812C12.1724 0.0703125 11.8283 0.0703125 11.5785 0.257812C11.4716 0.337969 8.95771 2.25141 8.95771 4.73859C8.95771 6.75937 10.6176 8.40141 11.2972 8.98922V13.7681L9.79349 12.2639C9.85818 11.3681 9.87084 9.03281 8.44209 7.60406C7.21106 6.37303 5.04107 6.06717 3.42037 6.28875C3.111 6.33328 2.86818 6.57609 2.82412 6.88547C2.8049 7.01766 2.38021 10.1484 4.13896 11.9072C5.30803 13.0762 7.08318 13.2802 8.18099 13.2802Z" fill="white"/>
    <path d="M3.51375 22.1265H0V23.0047C0 23.4897 0.393188 23.8829 0.878203 23.8829H5.87016C5.56687 22.8685 4.62516 22.1265 3.51375 22.1265Z" fill="white"/>
    <path d="M3.51375 18.9639H0.878203C0.393188 18.9639 0 19.3571 0 19.8421V20.7203H3.51375C5.40516 20.7203 6.9825 22.0862 7.31391 23.8829H9.09188C8.74453 21.1136 6.37547 18.9639 3.51375 18.9639Z" fill="white"/>
    <path d="M23.1215 18.9639H7.72656C8.37297 19.4495 8.93313 20.0443 9.37984 20.7203H23.9997V19.8421C23.9997 19.3571 23.6065 18.9639 23.1215 18.9639Z" fill="white"/>
    <path d="M10.5073 23.8829H23.1221C23.6071 23.8829 24.0003 23.4897 24.0003 23.0047V22.1265H10.0977C10.3058 22.6824 10.4459 23.2712 10.5073 23.8829Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1648">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Agriculture</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i6.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1911)">
    <path d="M18.6997 1.05882C18.6997 0.474071 18.2257 0 17.6409 0C17.0561 0 16.582 0.474071 16.582 1.05882V2.11765H17.6409C18.2257 2.11765 18.6997 1.64358 18.6997 1.05882Z" fill="white"/>
    <path d="M14.1116 2.11765H15.1704V1.05882C15.1704 0.474071 14.6964 0 14.1116 0C13.5268 0 13.0527 0.474071 13.0527 1.05882C13.0527 1.64358 13.5268 2.11765 14.1116 2.11765Z" fill="white"/>
    <path d="M10.2295 7.38818H17.2883V9.8823H10.2295V7.38818Z" fill="white"/>
    <path d="M10.2295 3.5293H17.2883V5.97636H10.2295V3.5293Z" fill="white"/>
    <path d="M18.7002 3.5293H21.5237V5.97636H18.7002V3.5293Z" fill="white"/>
    <path d="M18.7002 7.38818H21.5237V9.8823H18.7002V7.38818Z" fill="white"/>
    <path d="M21.8762 21.8825H15.2089C14.556 21.8825 13.9189 21.654 13.4152 21.2391L10.5732 18.9015C10.8868 18.5202 11.1564 18.1924 11.4701 17.8112L13.2772 19.2919C13.7727 19.6979 14.5024 19.6313 14.9162 19.1423C15.3294 18.654 15.2754 17.9247 14.7947 17.5027L10.135 13.4119H1.06445V20.4707H7.79208L12.735 24.0001H21.8762C22.461 24.0001 22.935 23.5261 22.935 22.9413C22.935 22.3565 22.461 21.8825 21.8762 21.8825Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1911">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Hospitality</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i15.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1659)">
    <path d="M4.10254 1.12015C4.10254 1.73782 4.60452 2.2403 5.22159 2.2403H19.7389V0H5.22159C4.60452 0 4.10254 0.50248 4.10254 1.12015Z" fill="white"/>
    <path d="M15.0109 10.7054C15.0109 8.22233 17.029 6.20223 19.5096 6.20223H22.788V3.64812H8.67073V5.5953H7.26462V3.64812H5.22148C4.67356 3.64812 4.16628 3.47198 3.75195 3.17407V9.67586C4.68416 9.3019 5.70092 9.09573 6.76503 9.09573C6.93284 9.09573 7.0993 9.10145 7.26462 9.11154V7.6971H8.67073V9.32222C12.2342 10.1829 14.8896 13.4008 14.8896 17.2283C14.8896 17.6512 14.8571 18.0665 14.7947 18.4721H22.788V15.2086H19.5096C17.029 15.2086 15.0109 13.1885 15.0109 10.7054Z" fill="white"/>
    <path d="M8.53152 17.803H6.13574V18.8649H8.53152C8.82402 18.8649 9.06196 18.6267 9.06196 18.334C9.06196 18.0412 8.82398 17.803 8.53152 17.803Z" fill="white"/>
    <path d="M8.53152 15.3335H6.13574V16.3955H8.53152C8.82402 16.3955 9.06196 16.1572 9.06196 15.8645C9.06196 15.5717 8.82398 15.3335 8.53152 15.3335Z" fill="white"/>
    <path d="M13.5304 17.2282C13.5304 13.4942 10.4955 10.4563 6.76519 10.4563C3.03488 10.4563 0 13.4942 0 17.2282C0 20.9622 3.03488 24 6.76519 24C10.4955 24.0001 13.5304 20.9622 13.5304 17.2282ZM10.4684 18.3338C10.4684 19.3317 9.71105 20.1557 8.74158 20.2607V21.3454H7.33547V20.2723H6.13603V21.3454H4.72992V20.2723H3.61102V18.8648H4.72992V15.3334H3.61102V13.9259H4.72992V12.8528H6.13603V13.9259H7.33547V12.8528H8.74158V13.9375C9.71105 14.0425 10.4684 14.8665 10.4684 15.8644C10.4684 16.3332 10.3012 16.7636 10.0235 17.0991C10.3012 17.4347 10.4684 17.8651 10.4684 18.3338Z" fill="white"/>
    <path d="M19.5095 7.56299C17.7784 7.56299 16.3701 8.97269 16.3701 10.7054C16.3701 12.4382 17.7784 13.8479 19.5095 13.8479H23.9997V7.56299H19.5095ZM19.2814 11.7007L18.287 10.7054L19.2813 9.71015L20.2756 10.7055L19.2814 11.7007Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1659">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Crypto & Blockchain</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i16.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1678)">
    <path d="M18.8994 1.26688C18.3023 0.704908 17.5382 0.435059 16.768 0.435059C15.9011 0.435059 15.0256 0.776868 14.3728 1.4305L14.0927 1.71063L13.8125 1.42965C13.1598 0.776868 12.2843 0.435059 11.4173 0.435059C10.6472 0.435059 9.88302 0.704908 9.28592 1.26688C7.97266 2.50305 7.94953 4.57104 9.21568 5.83719L14.0927 10.7142L18.9697 5.83719C20.2358 4.57104 20.2127 2.50305 18.8994 1.26688Z" fill="white"/>
    <path d="M23.6868 13.1978C22.9372 12.6897 22.054 12.8337 21.2718 13.2851C20.4897 13.7366 15.9991 17.5762 15.9991 17.5762L11.5787 17.577C11.3731 17.577 11.1503 17.3457 11.1503 17.141C11.1503 16.9003 11.3602 16.7126 11.5787 16.7126H14.2832C15.2298 16.7126 16.2895 16.0958 16.2895 14.9993C16.2895 13.8343 15.2298 13.286 14.2832 13.286C12.6409 13.286 12.3214 13.2928 12.3214 13.2928C11.6635 13.2928 10.9961 13.2534 10.4821 12.9784C9.79682 12.6272 9.00697 12.4285 8.16401 12.4285C6.7488 12.4285 5.4818 12.993 4.61314 13.8831L0 18.4251L5.13999 23.5651L6.85332 21.8518H15.5288C16.3923 21.8518 17.2258 21.5348 17.8709 20.9617L23.745 14.3722C24.104 14.0536 24.0834 13.4676 23.6868 13.1978Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1678">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Non-Profit Organizations(NPO)</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i17.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1689)">
    <path d="M21.8906 0H2.10938C0.946406 0 0 0.946406 0 2.10938V3.04688H24V2.10938C24 0.946406 23.0536 0 21.8906 0Z" fill="white"/>
    <path d="M9.46298 11.0958L11.9679 13.2877L15.6278 9.62784C15.9176 9.33802 16.3852 9.35939 16.6505 9.65789L18.4219 11.6506V7.82812H5.57812V13.7856L8.52703 11.1047C8.79141 10.8643 9.19406 10.8605 9.46298 11.0958Z" fill="white"/>
    <path d="M18.4219 13.7673L16.0949 11.1494L12.4972 14.7471C12.2354 15.0089 11.8155 15.0228 11.537 14.7791L9.00891 12.5671L5.57812 15.686V16.9218H18.4219V13.7673Z" fill="white"/>
    <path d="M0 21.8906C0 23.0536 0.946406 24 2.10938 24H21.8906C23.0536 24 24 23.0536 24 21.8906V4.45312H0V21.8906ZM6.87216 21.1222L6.12216 21.8722C5.84756 22.1467 5.40239 22.1467 5.1278 21.8722L4.3778 21.1222C4.1032 20.8476 4.1032 20.4024 4.3778 20.1278C4.65234 19.8533 5.09756 19.8533 5.37216 20.1278L5.625 20.3806L5.87784 20.1278C6.15239 19.8533 6.59761 19.8533 6.8722 20.1278C7.14675 20.4024 7.14675 20.8476 6.87216 21.1222ZM10.875 21.7031H9.375C8.98669 21.7031 8.67188 21.3883 8.67188 21C8.67188 20.6117 8.98669 20.2969 9.375 20.2969H10.875C11.2633 20.2969 11.5781 20.6117 11.5781 21C11.5781 21.3883 11.2633 21.7031 10.875 21.7031ZM15.375 21.7031H13.875C13.4867 21.7031 13.1719 21.3883 13.1719 21C13.1719 20.6117 13.4867 20.2969 13.875 20.2969H15.375C15.7633 20.2969 16.0781 20.6117 16.0781 21C16.0781 21.3883 15.7633 21.7031 15.375 21.7031ZM4.17188 7.125C4.17188 6.73669 4.48669 6.42188 4.875 6.42188H19.125C19.5133 6.42188 19.8281 6.73669 19.8281 7.125V17.625C19.8281 18.0133 19.5133 18.3281 19.125 18.3281H4.875C4.48669 18.3281 4.17188 18.0133 4.17188 17.625V7.125Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1689">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Social Media</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i18.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
  <g clip-path="url(#clip0_171_1927)">
    <path d="M23.3996 14.9133H21.3115C21.5244 15.496 21.6406 16.1249 21.6406 16.7803V24.6721C21.6406 24.9453 21.5931 25.2076 21.5065 25.4516H24.9586C26.2481 25.4516 27.2972 24.4025 27.2972 23.113V18.8109C27.2972 16.6618 25.5487 14.9133 23.3996 14.9133Z" fill="white"/>
    <path d="M5.95344 16.7803C5.95344 16.1249 6.06972 15.496 6.28255 14.9133H4.19448C2.04534 14.9133 0.296875 16.6618 0.296875 18.8109V23.1131C0.296875 24.4025 1.34592 25.4516 2.63544 25.4516H6.08754C6.00101 25.2076 5.95344 24.9453 5.95344 24.6721V16.7803Z" fill="white"/>
    <path d="M16.1839 12.8828H11.4103C9.26116 12.8828 7.5127 14.6313 7.5127 16.7804V24.6721C7.5127 25.1026 7.86169 25.4517 8.29222 25.4517H19.302C19.7325 25.4517 20.0815 25.1027 20.0815 24.6721V16.7804C20.0815 14.6313 18.3331 12.8828 16.1839 12.8828Z" fill="white"/>
    <path d="M13.7967 2.5481C11.2121 2.5481 9.10938 4.65083 9.10938 7.23551C9.10938 8.98866 10.077 10.5198 11.506 11.3237C12.1838 11.705 12.9652 11.9229 13.7967 11.9229C14.6282 11.9229 15.4097 11.705 16.0875 11.3237C17.5165 10.5198 18.4841 8.98861 18.4841 7.23551C18.4841 4.65088 16.3814 2.5481 13.7967 2.5481Z" fill="white"/>
    <path d="M5.56607 6.91724C3.63309 6.91724 2.06055 8.48978 2.06055 10.4228C2.06055 12.3557 3.63309 13.9283 5.56607 13.9283C6.0564 13.9283 6.52331 13.8267 6.94745 13.6442C7.68078 13.3284 8.28543 12.7696 8.65958 12.0695C8.9222 11.5782 9.0716 11.0177 9.0716 10.4228C9.0716 8.48983 7.49905 6.91724 5.56607 6.91724Z" fill="white"/>
    <path d="M22.028 6.91724C20.095 6.91724 18.5225 8.48978 18.5225 10.4228C18.5225 11.0177 18.6719 11.5782 18.9345 12.0695C19.3086 12.7696 19.9133 13.3285 20.6466 13.6442C21.0707 13.8267 21.5377 13.9283 22.028 13.9283C23.961 13.9283 25.5335 12.3557 25.5335 10.4228C25.5335 8.48978 23.961 6.91724 22.028 6.91724Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1927">
      <rect width="27" height="27" fill="white" transform="translate(0.296875 0.5)"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Staff / HR Applications</p>
                  </div>
                </div>
              </div>
              <div className="port_comp">
                <div className="port_border">
                  <div className="icon">
                    {/* <img src="./assets/images/portfolio/c_i19.png" alt="" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_171_1722)">
    <path d="M18.0851 0.0812988H1.42409C0.637593 0.0812988 0 0.718892 0 1.50539C0 2.29194 0.637593 2.92948 1.42409 2.92948L4.44276 2.93284C4.88314 2.93284 5.24025 3.28989 5.24025 3.73033C5.24025 4.17077 4.88314 4.52782 4.44276 4.52782H1.9154V10.5761H1.42409C0.637593 10.5761 0 11.2136 0 12.0002C0 12.7867 0.637593 13.4243 1.42409 13.4243L4.44276 13.4284C4.88314 13.4284 5.24025 13.7854 5.24025 14.2259C5.24025 14.6663 4.88314 15.0234 4.44276 15.0234H1.9154V21.0707H1.42409C0.637593 21.0707 0 21.7083 0 22.4948C0 23.2813 0.637593 23.9189 1.42409 23.9189H13.9685C12.4124 22.6468 11.4171 20.7129 11.4171 18.5509C11.4171 16.9552 12.4095 14.841 14.4509 12.0874C15.8593 10.1877 17.2484 8.69294 17.3069 8.63028L17.5939 8.32245V2.92948H18.0852C18.8717 2.92948 19.5093 2.29194 19.5093 1.50539C19.5092 0.718892 18.8716 0.0812988 18.0851 0.0812988Z" fill="white"/>
    <path d="M21.4328 13.2491C20.1858 11.567 18.921 10.2062 18.9084 10.1926C18.8439 10.1235 18.7535 10.0842 18.659 10.0842C18.5645 10.0842 18.4742 10.1235 18.4097 10.1926C18.397 10.2062 17.1321 11.567 15.8853 13.2491C14.1819 15.5466 13.3184 17.3301 13.3184 18.55C13.3184 21.495 15.7142 23.8911 18.6591 23.8911C21.6041 23.8911 24.0001 21.4951 24.0001 18.55C23.9998 17.33 23.1361 15.5466 21.4328 13.2491ZM19.1924 22.1626C18.9125 22.2288 18.6239 22.2623 18.3347 22.2623C16.2794 22.2623 14.6073 20.5902 14.6073 18.5349C14.6073 18.2514 14.6945 17.7382 15.11 16.9016C15.1518 16.8174 15.2481 16.7757 15.338 16.8025C15.4279 16.8293 15.4857 16.9169 15.4745 17.0102C15.465 17.0907 15.4602 17.1665 15.4602 17.2355C15.4602 19.4385 17.027 21.3521 19.1858 21.7856C19.2748 21.8033 19.3392 21.8808 19.3408 21.9715C19.3425 22.0623 19.2807 22.1417 19.1924 22.1626Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_171_1722">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                  </div>
                  <div className="com_name">
                    <p>Oil And Gas</p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>

          <div className="main_portfilo_slider">
            <Slider
              asNavFor={nav1}
              ref={(slider) => (sliderRef2 = slider)}
              slidesToShow={1}
              waitForAnimate={false}
              fade={true}
              dots={false}
              arrows={false} 
              adaptiveHeight={true}
            >
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl1.png" alt="" />
                  </Tab>
                  {/* <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl17.png" alt="" />
                  </Tab> */}
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl18.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl19.png" alt="" />
                  </Tab>
                </TabList>
                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_1.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl1_1.png" alt="" />
                      </div>
                      {/* <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>Website: Built using WordPress</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Mobile App: Developed in Kotlin                          </span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Admin Panel:  Node.js, Next.js, React.js, MongoDB</span>
                        </a>
                      </div> */}
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#334b35" }}>
                            ANBR - Arihant Group of Industries
                          </h2>
                          <p>
                            Arihant Group is a global leader in the chemical,
                            agriculture, and fertilizer sectors, recognized for
                            its massive turnover and widespread influence. We
                            had the privilege of collaborating with this
                            powerhouse to enhance their digital presence and
                            streamline operations.
                          </p>
                        </div>

                        <div className="contributions">
                          <h3 style={{ color: "#334b35" }}>
                            Our Contributions to Their Success:
                          </h3>
                          <ul>
                            <li>
                              <strong>Corporate Website:</strong> Designed with
                              dynamic UI/UX and seamless navigation to reflect
                              the brand’s identity.
                            </li>
                            <li>
                              <strong>Sales Management App:</strong> Developed a
                              mobile app with an intuitive admin panel to
                              optimize operations.
                            </li>
                            <li>
                              <strong>ERP System:</strong> Integrated all
                              departments, streamlining daily operations and
                              boosting efficiency.
                            </li>
                            <li>
                              <strong>Ongoing SEO:</strong> Continuous SEO
                              management to improve search engine rankings and
                              online visibility.
                            </li>
                            <li>
                              <strong>Content Creation:</strong> Crafting
                              project catalogs, posts, and engaging marketing
                              videos for effective outreach.
                            </li>
                          </ul>
                        </div>

                        <div className="technologies">
                          <h3 style={{ color: "#334b35" }}>
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              <strong>Website:</strong> Built using{" "}
                              <span className="tech">WordPress</span>
                            </li>
                            <li className="tech-item">
                              <strong>Mobile App:</strong> Developed in{" "}
                              <span className="tech">Kotlin</span>
                            </li>
                            <li className="tech-item">
                              <strong>Admin Panel:</strong>{" "}
                              <span className="tech">Node.js</span>,{" "}
                              <span className="tech">Next.js</span>,{" "}
                              <span className="tech">React.js</span>, and{" "}
                              <span className="tech">MongoDB</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  {/* <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_17.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl177.png" alt="" />
                      </div>
                      <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>UX</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Web Development</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>SEO</span>
                        </a>
                      </div>
                      <p>
                        Vorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vulputate libero et velit interdum, ac aliquet odio
                        mattis. Class aptent taciti sociosqu ad litora torquent
                        per conubia nostra, per inceptos himenaeos. Curabitur
                        tempus urna at turpis condimentum lobortis.
                      </p>
                    </div>
                  </TabPanel> */}
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_18.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl188.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#0cacd3" }}>Faire Venture</h2>
                          <p>
                            Faire Venture is a leading Canadian trading company
                            specializing in the sale of protective plastic
                            materials used for roofing. We were honored to
                            partner with them to enhance their digital presence
                            and establish a strong brand identity.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#0cacd3" }}>Key Features:</h3>
                          <ul>
                            <li>
                              <strong>Branding:</strong> Designed a unique and
                              professional brand identity that reflects their
                              expertise in the roofing protection industry.
                            </li>
                            <li>
                              <strong>Website Design & Development:</strong>{" "}
                              Created a dynamic, responsive website that
                              showcases their products and services while
                              providing a seamless user experience.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#0cacd3" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website Development:</strong>{" "}
                              <span className="tech"> HTML, CSS, WordPress</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_19.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl199.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#000" }}>
                            Al-Sabih – AR-Powered Window & Door Mesh Application
                          </h2>
                          <p>
                            Al-Sabih is a leading Gulf-based company
                            specializing in the design and manufacture of
                            windows, doors, and mesh systems. To enhance the
                            customer experience and showcase their innovative
                            products, we developed an advanced Augmented Reality
                            (AR) mobile application.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#000" }}>Key Features:</h3>
                          <ul>
                            <li>
                              <strong>AR Mobile Application:</strong> Developed
                              a seamless and user-friendly AR mobile app using
                              Unity, available for both Android and iOS. The app
                              allows users to visualize how different mesh
                              designs would look on their windows and doors in
                              real-time.
                            </li>
                            <li>
                              <strong>Admin Panel:</strong> A robust admin panel
                              was created to manage mesh designs, track user
                              activity, and ensure smooth operations.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#000" }}> Technologies Used:</h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App Development:</strong>{" "}
                              <span className="tech">
                                {" "}
                                Unity for both Android & iOS
                              </span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech">
                                {" "}
                                PHP, MySQL for data management and
                                administration
                              </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
             
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl3.png" alt="" />
                  </Tab>
                </TabList>
                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_3.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl3.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#0220d6" }}>
                            Shaksham IQ – Empowering Education for the Deaf and
                            Mute Community
                          </h2>
                          <p>
                            Shaksham IQ is an innovative organization dedicated
                            to providing education for the hearing-impaired
                            community. We developed a cutting-edge native
                            Android mobile app to offer them a comprehensive
                            learning platform. The app is designed to break down
                            barriers to education by enabling students to access
                            online lectures, video courses, exams, and more, all
                            from the convenience of their mobile devices.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#0220d6" }}>
                            {" "}
                            Our Contributions to Their Success:
                          </h3>
                          <ul>
                            <li>
                              <strong>Live Online Lectures:</strong> Students
                              can attend interactive live sessions with
                              real-time teacher-student engagement.
                            </li>
                            <li>
                              <strong>Video Courses:</strong> Extensive library
                              of video courses for self-paced learning across
                              various subjects.
                            </li>
                            <li>
                              <strong>Exams & Assessments:</strong> Allows
                              students to take quizzes and exams to track their
                              progress and knowledge retention.
                            </li>
                            <li>
                              <strong>User-Friendly Interface:</strong> Simple,
                              intuitive design to make learning easy for
                              everyone.
                            </li>
                            <li>
                              <strong>Push Notifications:</strong> Keeps
                              students updated with class schedules, exam dates,
                              and important announcements.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#0220d6" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong> Developed in{" "}
                              <span className="tech">
                                {" "}
                                Native Android (Java/Kotlin)
                              </span>{" "}
                              <span className="tech"> node.js</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech"> node.js</span> , and{" "}
                              <span className="tech"> MongoDB</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl2.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl21.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl22.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide" height='fit-content'>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_2.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl2.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#000" }}>
                            {" "}
                            Movement Physiotherapy Clinic - Dubai’s Leading
                            Physiotherapy Clinic
                          </h2>
                          <p>
                            {" "}
                            Movement Physiotherapy Clinic, ranked as Dubai's #1
                            physiotherapy clinic, trusted us to craft a
                            comprehensive digital experience that represents
                            their commitment to patient care and wellness. Our
                            collaboration helped elevate their brand and improve
                            their digital presence.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#000" }}>
                            {" "}
                            Our Contributions to Their Success:
                          </h3>
                          <ul>
                            <li>
                              {" "}
                              <strong> Logo & Branding:</strong> Designed a
                              unique logo and cohesive branding to reflect the
                              clinic’s professional approach and care.
                            </li>
                            <li>
                              {" "}
                              <strong> Website UI/UX:</strong> Developed a
                              user-friendly, intuitive website with dynamic
                              UI/UX design to provide an exceptional patient
                              experience.
                            </li>
                            <li>
                              {" "}
                              <strong>
                                {" "}
                                Social Media SEO & Marketing:
                              </strong>{" "}
                              Created engaging SEO-optimized content for social
                              media to increase brand visibility and patient
                              engagement.
                            </li>
                            <li>
                              {" "}
                              <strong> Online Appointment System:</strong>{" "}
                              Developed an easy-to-use system for patients to
                              book appointments online.
                            </li>
                            <li>
                              {" "}
                              <strong>
                                {" "}
                                Patient Records & Prescription Management:
                              </strong>{" "}
                              Integrated a feature to maintain patient data,
                              medical records, and prescriptions digitally for
                              better management.
                            </li>
                            <li>
                              {" "}
                              <strong> Ongoing Features:</strong> The
                              application is currently being enhanced with
                              additional features like real-time chat for
                              patient inquiries and appointment reminders.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#000" }}> Technologies Used:</h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website:</strong> Built using{" "}
                              <span className="tech"> WordPress</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong> Developed in{" "}
                              <span className="tech"> React Native</span>{" "}
                              <span className="tech"> node.js</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech"> React.js</span> , and{" "}
                              <span className="tech"> MongoDB</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_21.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl211.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#000" }}>
                            Wellman Group - Leading Provider of Medical
                            Equipment
                          </h2>
                          <p>
                            {" "}
                            Wellman Group, established in 2013, is a trusted
                            name in the medical equipment industry, specializing
                            in providing essential surgical instruments and
                            operation theater supplies. With over 100 hospitals
                            served, Wellman has become a reliable partner for
                            healthcare facilities in need of high-quality
                            medical equipment. We had the privilege of designing
                            and developing their digital presence to reflect
                            their expertise and innovation.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#000" }}>
                            {" "}
                            Our Contributions to Their Success:
                          </h3>
                          <ul>
                            <ul>
                              <li>
                                <strong>Website Design & Development:</strong>{" "}
                                Created a modern, professional website
                                showcasing their vast range of medical equipment
                                and services.
                              </li>
                              <li>
                                <strong>User Experience:</strong> Focused on
                                intuitive UI/UX to ensure ease of navigation for
                                clients seeking products and information.
                              </li>
                            </ul>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active " data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_22.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl222.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#013942" }}>
                            {" "}
                            Life Line – Revolutionizing Healthcare Appointments
                          </h2>
                          <p>
                            {" "}
                            Life Line is an intuitive and seamless appointment
                            booking app designed to simplify the way patients
                            schedule their healthcare appointments. With
                            features like patient data management, real-time
                            appointment scheduling, and easy access to medical
                            records, Life Line ensures a smooth and efficient
                            experience for both healthcare providers and
                            patients.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#013942" }}>Key Features:</h3>
                          <ul>
                            <li>
                              <strong>Online Appointment Booking:</strong>{" "}
                              Allows patients to book appointments with ease,
                              anytime and anywhere.
                            </li>
                            <li>
                              <strong>Patient Data Management:</strong> Securely
                              stores patient information, medical records, and
                              prescriptions.
                            </li>
                            <li>
                              <strong>Reminder Notifications:</strong> Sends
                              timely reminders to patients about their upcoming
                              appointments.
                            </li>
                            <li>
                              <strong>User-Friendly Interface:</strong> Designed
                              with simplicity and efficiency in mind for both
                              patients and healthcare providers.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#013942" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong> Developed in{" "}
                              <span className="tech"> React Native</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech"> node.js</span> , and{" "}
                              <span className="tech"> MongoDB</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl23.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl4.png" alt="" />
                  </Tab>
                </TabList>
                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_23.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl233.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#031042" }}>
                            Rare Ever – Empowering Financial Innovation
                          </h2>
                          <p>
                            Rare Ever is a pioneering fintech company reshaping
                            the financial services landscape. We collaborated
                            closely with them to create an innovative,
                            user-friendly website that not only represents their
                            modern approach but also enhances their customer
                            experience.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#031042" }}>
                            {" "}
                            Our Contributions to Their Success:
                          </h3>
                          <ul>
                            <li>
                              {" "}
                              <strong>
                                Custom Website Design & Development:
                              </strong>{" "}
                              Designed a sleek, dynamic website with seamless
                              navigation and real-time updates, reflecting their
                              forward-thinking fintech vision.
                            </li>
                            <li>
                              {" "}
                              <strong>Brand Identity:</strong> Crafted a
                              distinctive logo and cohesive branding to align
                              with Rare Ever's unique identity and market
                              presence.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#031042" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website:</strong> Built using{" "}
                              <span className="tech"> WordPress</span> and{" "}
                              <span className="tech">Custom HTML/CSS</span>
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Web Development:</strong> Developed in{" "}
                              <span className="tech"> JavaScript</span>{" "}
                              <span className="tech"> react.js</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_4.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl4.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#550e6f" }}>
                            Print – Revolutionizing Printing with Connected
                            Kiosk Systems
                          </h2>
                          <p>
                            Print is a one-of-a-kind project designed to
                            simplify and innovate the printing process through a
                            connected network of kiosks and printers. This
                            solution ensures seamless printing operations, even
                            across vast distances, without the need for
                            third-party dependencies.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#550e6f" }}>
                            Our Contribution:
                          </h3>
                          <ul>
                            <li>
                              <strong>Kiosk Application:</strong> Developed a
                              cutting-edge kiosk application using Electron.js
                              and Angular.js. The application enables users to
                              connect multiple printers across various
                              locations, allowing printouts to be initiated from
                              any kiosk to any connected printer.
                            </li>
                            <li>
                              <strong>Mobile Applications:</strong> Built native
                              iOS and Android apps to provide users with remote
                              access to the kiosk network for easy print
                              management.
                            </li>
                            <li>
                              <strong>Admin Panel:</strong> Designed a powerful
                              admin panel using Node.js and MongoDB for
                              centralized control, monitoring, and management of
                              kiosks and printers.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#550e6f" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Kiosk Application:</strong>{" "}
                              <span className="tech"> Electron.js, Angular.js</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Backend:</strong>{" "}
                              <span className="tech"> Node.js, MongoDB</span>{" "}
                              <span className="tech"> node.js</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong>Mobile Applications:</strong>{" "}
                              <span className="tech">
                                swift for iOS and kotlin for Android
                              </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl5.png" alt="" />
                  </Tab>
                  {/* <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl24.png" alt="" />
                  </Tab> */}
                  {/* <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl25.png" alt="" />
                  </Tab> */}
                </TabList>
                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_5.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl5.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#3d3e90" }}>
                            Alghanim - Al Bahar <br /> Revolutionizing the
                            Carpet and Decor Industry with AR
                          </h2>
                          <p>
                            Alghanim - Al Bahar is a leading brand in the Gulf,
                            specializing in carpets and decorative materials. We
                            had the privilege of partnering with them to enhance
                            their digital presence with a dynamic website and a
                            cutting-edge mobile application. Our goal was to
                            bring their products to life in an innovative way,
                            offering customers an interactive and immersive
                            experience.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#3d3e90" }}>
                            Key Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>Dynamic Website Development:</strong>{" "}
                              Designed and developed a user-friendly, responsive
                              website using WordPress and PHP, reflecting the
                              brand’s elegance and industry leadership.
                            </li>
                            <li>
                              <strong>AR-Enabled Mobile App:</strong> Developed
                              an interactive mobile application with Augmented
                              Reality (AR) features, allowing users to visualize
                              how carpets and decorative products would look in
                              their home or office.
                            </li>
                            <li>
                              <strong>Technology:</strong> The mobile app was
                              built using Unity for a seamless AR experience.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  {/* <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_24.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl244.png" alt="" />
                      </div>
                      <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>UX</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Web Development</span>
                        </a>
                      </div>
                      <p>
                        Vorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vulputate libero et velit interdum, ac aliquet odio
                        mattis. Class aptent taciti sociosqu ad litora torquent
                        per conubia nostra, per inceptos himenaeos. Curabitur
                        tempus urna at turpis condimentum lobortis.
                      </p>
                    </div>
                  </TabPanel> */}
                  {/* <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_25.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl255.png" alt="" />
                      </div>
                      <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>UX</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Web Development</span>
                        </a>
                      </div>
                      <p>
                        Vorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vulputate libero et velit interdum, ac aliquet odio
                        mattis. Class aptent taciti sociosqu ad litora torquent
                        per conubia nostra, per inceptos himenaeos. Curabitur
                        tempus urna at turpis condimentum lobortis.
                      </p>
                    </div>
                  </TabPanel> */}
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl6.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl26.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_6.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl6.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#ca250f" }}>
                            Davys Tourism – Elevating Dubai's Leading Travel
                            Agency with Digital Excellence
                          </h2>
                          <p>
                            Davys Tourism has been a prominent name in Dubai’s
                            travel industry for over a decade. We had the
                            opportunity to design and develop a visually
                            captivating corporate website that showcases their
                            extensive services and enhances their online
                            presence. In addition, we are supporting their
                            growth with a comprehensive digital marketing
                            strategy, including SEO and engaging content
                            creation.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#ca250f" }}>
                            Key Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>Corporate Website Development:</strong>{" "}
                              Designed and developed a modern, user-friendly
                              website to highlight their diverse travel services
                              and provide an enhanced customer experience.
                            </li>
                            <li>
                              <strong>Digital Marketing & SEO:</strong> Managing
                              ongoing digital marketing efforts, including SEO
                              optimization to boost online visibility and
                              attract more customers.
                            </li>
                            <li>
                              <strong>Content Creation:</strong> Creating
                              compelling content for social media, including
                              Instagram Reels, videos, and posts to engage with
                              their audience and promote their travel packages.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#ca250f" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website:</strong> Built using{" "}
                              <span className="tech"> WordPress,</span>{" "}
                              <span className="tech"> PHP</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong>SEO & Marketing Tools:</strong>{" "}
                              <span className="tech"> Google Analytics</span>{" "}
                              <span className="tech"> SEMrush</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_26.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl266.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#be542b" }}>
                            Avaya Tours – Crafting a Strong Digital Identity for
                            Dubai's Leading Travel Agency
                          </h2>
                          <p>
                            Avaya Tours, a renowned Dubai-based travel agency,
                            approached us to design a unique logo and establish
                            a compelling digital presence. We're excited to be
                            working on their website, which will be designed to
                            reflect the agency's quality services and bring
                            their travel solutions to a broader audience.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#be542b" }}>
                            {" "}
                            Key Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>Logo Design:</strong> Created a custom,
                              professional logo that represents the brand's
                              essence and values in the travel industry.
                            </li>
                            <li>
                              <strong>Website Development (Ongoing):</strong>{" "}
                              Currently developing a dynamic website that will
                              offer an exceptional user experience and showcase
                              their travel offerings effectively.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#be542b" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website:</strong> Built using{" "}
                              <span className="tech"> WordPress & PHP</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl7.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_7.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl7.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#000" }}>
                            Fremantle – Redefining Media Excellence
                          </h2>
                          <p>
                            Who doesn’t know Fremantle? A globally renowned
                            media powerhouse, Fremantle is a leading television
                            production and distribution company that has set
                            benchmarks in the entertainment industry.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#000" }}>Our Contribution</h3>
                          <ul>
                            <li>
                              We had the privilege of contributing to the Indian
                              version of Fremantle’s website, ensuring a
                              seamless, engaging, and user-friendly digital
                              experience. It’s a matter of immense pride for us
                              to be associated with such a prestigious name in
                              the global media landscape.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  {/* <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl8.png" alt="" />
                  </Tab> */}
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl27.png" alt="" />
                  </Tab>
                  {/* <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl28.png" alt="" />
                  </Tab> */}
                </TabList>

                <div className="port_slide">
                  {/* <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_8.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl88.png" alt="" />
                      </div>
                      <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>UX</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Mobile App</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Development</span>
                        </a>
                      </div>
                      <p>
                        Vorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vulputate libero et velit interdum, ac aliquet odio
                        mattis. Class aptent taciti sociosqu ad litora torquent
                        per conubia nostra, per inceptos himenaeos. Curabitur
                        tempus urna at turpis condimentum lobortis.
                      </p>
                    </div>
                  </TabPanel> */}
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_27.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl277.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#9632a1" }}>
                            DEAL – Revolutionizing Property Transactions in the
                            Gulf with a Cutting-Edge Mobile App
                          </h2>
                          <p>
                            DEAL is a dynamic mobile app designed for users in
                            Gulf countries to simplify property transactions. It
                            enables builders and property owners to directly
                            list their properties for sale or rent, while
                            potential buyers and renters can easily browse and
                            connect with the property owners. We developed this
                            native app for both iOS and Android, offering a
                            seamless user experience and innovative features.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#9632a1" }}> Key Features:</h3>
                          <ul>
                            <li>
                              <strong>Property Listing & Browsing:</strong>{" "}
                              Builders and property owners can list their
                              properties, while users can effortlessly browse
                              through available properties for purchase or rent.
                            </li>
                            <li>
                              <strong>Direct Contact:</strong> A feature that
                              allows users to directly connect with property
                              owners or agents for further inquiries or
                              negotiations.
                            </li>
                            <li>
                              <strong>Property Search Filters:</strong> Advanced
                              filters to help users search properties based on
                              location, price, and other preferences.
                            </li>
                            <li>
                              <strong>Favorites & Notifications:</strong> Users
                              can save their favorite properties and receive
                              notifications for new listings or price changes.
                            </li>
                            <li>
                              <strong>Seamless User Interface:</strong> Easy
                              navigation and smooth user experience, making
                              property browsing a hassle-free experience.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#9632a1" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website:</strong> Built using{" "}
                              <span className="tech"> WordPress</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong> Developed using{" "}
                              <span className="tech">
                                Kotlin (for Android) & Swift (for iOS)
                              </span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Backend:</strong>{" "}
                              <span className="tech"> node.js</span> , and{" "}
                              <span className="tech"> MongoDB</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  {/* <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_28.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl288.png" alt="" />
                      </div>
                      <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>UX</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Mobile App</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Development</span>
                        </a>
                      </div>
                      <p>
                        Vorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vulputate libero et velit interdum, ac aliquet odio
                        mattis. Class aptent taciti sociosqu ad litora torquent
                        per conubia nostra, per inceptos himenaeos. Curabitur
                        tempus urna at turpis condimentum lobortis.
                      </p>
                    </div>
                  </TabPanel> */}
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl9.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_9.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl99.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#faa93e" }}>
                            So Solar Power – Illuminating a Sustainable Future
                          </h2>
                          <p>
                            So Solar Power, a leading solar energy company based
                            in the US, specializes in rooftop solar solutions
                            that generate clean and efficient electricity.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#faa93e" }}>
                            Our Contribution:
                          </h3>
                          <ul>
                            <li>
                              We managed their SEO strategy, enhancing their
                              online visibility and driving targeted traffic to
                              their platform. Through optimized content and
                              tailored techniques, we helped amplify their reach
                              and connect with eco-conscious audiences.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl10.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl29.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img
                      src="./assets/images/portfolio/fl322.png"
                      height={"70px"}
                      alt=""
                    />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl_38.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_10.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl10.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#468027" }}>
                            Akshay Seeds – Transforming Agriculture with
                            Innovation
                          </h2>
                          <p>
                            {" "}
                            Akshay Seeds, a prominent player in the agricultural
                            sector, is committed to empowering farmers with
                            top-quality seeds and innovative solutions. We
                            partnered with them to enhance their digital
                            presence and streamline workforce operations.{" "}
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#468027" }}>
                            Our Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>Corporate Website:</strong> Developed a
                              professional and dynamic website using WordPress,
                              showcasing their extensive range of agricultural
                              products.
                            </li>
                            <li>
                              <strong>Employee Management App:</strong> Designed
                              a robust mobile application in Kotlin for tracking
                              staff attendance, geolocation, daily and travel
                              allowances, and generating sales and performance
                              reports. Integrated with a powerful PHP Yii
                              framework admin panel for seamless management and
                              reporting.
                            </li>
                            <li>
                              <strong>SEO and Digital Marketing:</strong>{" "}
                              Implemented targeted SEO strategies and digital
                              marketing campaigns to boost their online
                              visibility and connect with a broader audience.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#468027" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website:</strong>{" "}
                              <span className="tech"> WordPress</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong>{" "}
                              <span className="tech"> Kotlin</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech"> PHP Yii framework </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_29.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl299.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#b8cf32" }}>
                            {" "}
                            Agristar genetics – Transforming Agriculture with
                            Innovation
                          </h2>
                          <p>
                            Agristar genetics, a prominent player in the
                            agricultural sector, is committed to empowering
                            farmers with top-quality seeds and innovative
                            solutions. We partnered with them to enhance their
                            digital presence and streamline workforce
                            operations.{" "}
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#b8cf32" }}>Key Features:</h3>
                          <ul>
                            <li>
                              <strong>Corporate Website:</strong> Developed a
                              professional and dynamic website using WordPress,
                              showcasing their extensive range of agricultural
                              products.
                            </li>
                            <li>
                              <strong>Employee Management App:</strong> Designed
                              a robust mobile application in Kotlin for tracking
                              staff attendance, geolocation, daily and travel
                              allowances, and generating sales and performance
                              reports. Integrated with a powerful PHP Yii
                              framework admin panel for seamless management and
                              reporting.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#b8cf32" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website:</strong>{" "}
                              <span className="tech"> WordPress</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong>{" "}
                              <span className="tech"> Kotlin</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech"> PHP Yii framework </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_37.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl37.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#b8cf32" }}>
                            Kirtiman Seeds – Simplifying Workforce Management
                          </h2>
                          <p>
                            Kirtiman Seeds, a prominent name in the agricultural
                            industry, approached us to streamline their
                            workforce operations. We delivered a powerful and
                            efficient solution to meet their needs.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#b8cf32" }}>Key Features:</h3>
                          <ul>
                            <li>
                              <strong>Employee Management App:</strong>{" "}
                              Developed a dedicated mobile application in Kotlin
                              to manage staff attendance, geolocation tracking,
                              expense records (travel and daily allowances), and
                              performance and sales reporting. The app is
                              supported by a robust PHP Yii framework admin
                              panel for seamless monitoring and data management.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#b8cf32" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong>{" "}
                              <span className="tech"> Kotlin</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech"> PHP Yii framework </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_38.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl388.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#b8cf32" }}>
                            Axis Seeds – Empowering Agriculture with Technology
                          </h2>
                          <p>
                            Axis Seeds, a leading giant in the agricultural
                            sector, is renowned for providing high-quality seeds
                            to farmers. We had the privilege to elevate their
                            digital landscape and optimize their workforce
                            management through tailored solutions.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#b8cf32" }}>
                            Our Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>Corporate Website:</strong> Developed a
                              dynamic website using WordPress, highlighting Axis
                              Seeds' services and offerings.
                            </li>
                            <li>
                              <strong>
                                Employee Management/Tracking App with Admin
                                Panel:
                              </strong>{" "}
                              Created a comprehensive mobile application in
                              Kotlin with features for staff attendance
                              tracking, geolocation monitoring, travel and daily
                              allowance management, and sales and performance
                              reporting. Supported by a robust PHP Yii framework
                              admin panel for efficient oversight and analytics.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#b8cf32" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website:</strong>{" "}
                              <span className="tech"> WordPress</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong>{" "}
                              <span className="tech"> Kotlin</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech"> PHP Yii framework </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl11.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl30.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl31.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_11.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl111.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#00402e" }}>
                            Fork & Flames – Modern Web Layout Design
                          </h2>
                          <p>
                            We crafted a sleek and contemporary web layout in
                            Figma, complemented by branding and logo design to
                            reflect the essence of today’s multi-cuisine
                            restaurants. This design emphasizes user-friendly
                            navigation, visually captivating elements, and a
                            seamless digital experience, tailored to elevate any
                            restaurant's online presence.
                          </p>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_30.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl303.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#000" }}>
                            Elysee Bistro – Modern Web Layout & Branding
                          </h2>
                          <p>
                            For Elysee Bistro, we delivered a refined web layout
                            in Figma paired with branding and logo design,
                            embodying the charm and elegance of a contemporary
                            bistro. The layout combines intuitive navigation,
                            aesthetic appeal, and a user-centric approach,
                            ensuring a delightful digital experience for modern
                            diners.
                          </p>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_31.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl313.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#91c11c" }}>
                            Divini Greenlang – A Luxurious Escape in Nature
                          </h2>
                          <p>
                            estled amidst serene nature, Divini Greenlang is a
                            luxurious resort renowned for hosting destination
                            weddings, parties, and grand functions. We are proud
                            to have played a role in enhancing their digital
                            presence.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#91c11c" }}>
                            Our Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>Dynamic Website:</strong> Designed an
                              elegant and engaging website to highlight the
                              resort's offerings.
                            </li>
                            <li>
                              <strong>UI/UX Prototype:</strong> Crafted
                              user-friendly and visually stunning prototypes in
                              Figma.
                            </li>
                            <li>
                              <strong>Web Development:</strong> Developed the
                              website using WordPress, ensuring smooth
                              navigation and functionality.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#91c11c" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Design & Prototype:</strong>{" "}
                              <span className="tech"> Figma</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong>Development Platform:</strong>{" "}
                              <span className="tech"> WordPress</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl12.png" alt="" />
                  </Tab>
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl32.png" alt="" />
                  </Tab>
                  {/* <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl33.png" alt="" />
                  </Tab> */}
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl34.png" alt="" />
                  </Tab>
                  {/* <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl35.png" alt="" />
                  </Tab> */}
                </TabList>
                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_12.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl122.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#a77e2c" }}>
                            Swiss Crown - Revolutionizing the Crypto Experience
                          </h2>
                          <p>
                            Swiss Crown is an innovative cryptocurrency token
                            that aims to offer a seamless and rewarding
                            experience for its users. We were excited to
                            contribute to the growth of Swiss Crown with a
                            complete digital ecosystem that includes an animated
                            HD design, website development, and advanced
                            features such as a trading platform, e-commerce
                            system, and a token-based game.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#a77e2c" }}>
                            Our Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>Official Website:</strong> Designed an
                              engaging animated HD website that captures the
                              essence of Swiss Crown’s vision.
                            </li>
                            <li>
                              <strong>Trading Platform:</strong> Developed a
                              robust trading platform to facilitate smooth
                              transactions and empower users to buy and sell
                              Swiss Crown tokens.
                            </li>
                            <li>
                              <strong>E-commerce System:</strong> Built an
                              e-commerce platform to support the utility of
                              Swiss Crown tokens in online purchases.
                            </li>
                            <li>
                              <strong>Token-based Game:</strong> Developed an
                              interactive game, giving users a unique way to
                              engage with the Swiss Crown ecosystem.
                            </li>
                            <li>
                              <strong>Social Media & Content Creation:</strong>{" "}
                              Managed social media marketing, content
                              generation, and brand awareness strategies to
                              reach and engage a global audience.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#a77e2c" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website Development:</strong>{" "}
                              <span className="tech"> HTML, CSS, JavaScript</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong>
                                {" "}
                                Trading Platform & E-commerce:
                              </strong>{" "}
                              <span className="tech">
                                {" "}
                                Custom-built solutions integrated with
                                blockchain technology
                              </span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Game Development:</strong>{" "}
                              <span className="tech">
                                Unity, Blockchain-based integrations
                              </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_32.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl323.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#2ca6e4" }}>NDI - Crypto</h2>
                          <p>
                            NDI is a rapidly growing cryptocurrency token that
                            has gained a strong client base over the past 4
                            years. With plans to launch its own blockchain soon,
                            NDI is poised for even greater success in the crypto
                            world. We are proud to have contributed to this
                            journey by developing their official website and a
                            robust desk system for crypto transactions,
                            including buying, selling, and staking.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#2ca6e4" }}>
                            Our Contributions:
                          </h3>
                          <ul>
                            <li> </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#2ca6e4" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website Development:</strong>{" "}
                              <span className="tech"> HTML, CSS</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Desk trading System:</strong>{" "}
                              <span className="tech"> PHP Yii Framework</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  {/* <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_33.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl333.png" alt="" />
                      </div>
                      <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>UX</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Mobile App</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Development</span>
                        </a>
                      </div>
                      <p>
                        Vorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vulputate libero et velit interdum, ac aliquet odio
                        mattis. Class aptent taciti sociosqu ad litora torquent
                        per conubia nostra, per inceptos himenaeos. Curabitur
                        tempus urna at turpis condimentum lobortis.
                      </p>
                    </div>
                  </TabPanel> */}
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_34.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl344.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#fe6d2f" }}>
                            EBN - Empowering the Crypto Community
                          </h2>
                          <p>
                            EBN is a rapidly emerging cryptocurrency token,
                            providing a platform for seamless transactions and a
                            range of utilities for its growing community. We had
                            the privilege of developing their official website
                            and integrating essential utilities to enhance user
                            experience and functionality.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#fe6d2f" }}>
                            Our Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>Official Website:</strong> A dynamic,
                              user-friendly website designed to showcase the
                              potential of EBN, built with modern technologies.
                            </li>
                            <li>
                              <strong>Utility Tools:</strong> Developed small
                              but impactful utilities to support the smooth
                              functioning of the EBN ecosystem.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#fe6d2f" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website Development:</strong>{" "}
                              <span className="tech"> HTML, CSS</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Utilities:</strong>{" "}
                              <span className="tech">
                                {" "}
                                Custom-built tools tailored to EBN's ecosystem
                              </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  {/* <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_35.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl355.png" alt="" />
                      </div>
                      <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>UX</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Mobile App</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Development</span>
                        </a>
                      </div>
                      <p>
                        Vorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vulputate libero et velit interdum, ac aliquet odio
                        mattis. Class aptent taciti sociosqu ad litora torquent
                        per conubia nostra, per inceptos himenaeos. Curabitur
                        tempus urna at turpis condimentum lobortis.
                      </p>
                    </div>
                  </TabPanel> */}
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  {/* <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl13.png" alt="" />
                  </Tab> */}
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl36.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  {/* <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_13.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl133.png" alt="" />
                      </div>
                      <div className="tag_list">
                        <a href="javascript:void(0)" className="let_start">
                          <span>UX</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Mobile App</span>
                        </a>
                        <a href="javascript:void(0)" className="let_start">
                          <span>Development</span>
                        </a>
                      </div>
                      <p>
                        Vorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vulputate libero et velit interdum, ac aliquet odio
                        mattis. Class aptent taciti sociosqu ad litora torquent
                        per conubia nostra, per inceptos himenaeos. Curabitur
                        tempus urna at turpis condimentum lobortis.
                      </p>
                    </div>
                  </TabPanel> */}
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_36.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl366.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#c21525" }}>
                            Blood Donation Mobile Application – Empowering Lives
                            in the Gulf
                          </h2>
                          <p>
                            We had the honor of developing a transformative
                            mobile application for a Gulf-based NGO to support
                            their blood donation initiatives. This app bridges
                            the gap between donors and recipients, making the
                            process seamless and efficient.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#c21525" }}>Key Features:</h3>
                          <ul>
                            <li>
                              <strong>Donor Registration & Management:</strong>{" "}
                              Easy onboarding and profile management for donors.
                            </li>
                            <li>
                              <strong>Real-Time Requests:</strong> Instant
                              notification for urgent blood requirements.
                            </li>
                            <li>
                              <strong>Blood Bank Locator:</strong> Locate nearby
                              blood banks and donation centers.
                            </li>
                            <li>
                              <strong>Donor History:</strong> Track past
                              donations and eligibility for the next donation.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#c21525" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App Development:</strong>{" "}
                              <span className="tech">
                                {" "}
                                Native Android (Kotlin) & iOS (Swift)
                              </span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App:</strong>{" "}
                              <span className="tech"> React Native</span>{" "}
                              <span className="tech"> node.js</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Backend Services:</strong>{" "}
                              <span className="tech"> Node.js and MongoDB</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl14.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_14.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl144.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#000" }}>
                            Monoliza – The Ultimate Platform for Models and
                            Photographers
                          </h2>
                          <p>
                            Monoliza is an innovative social media platform
                            designed for models and photographers to showcase
                            their portfolios and connect with potential clients.
                            With a seamless user interface, this platform allows
                            users to post, view, and hire professionals directly
                            through the app.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#000" }}>Key Features:</h3>
                          <ul>
                            <li>
                              <strong>Portfolio Management:</strong> Models and
                              photographers can upload and manage their
                              portfolios effortlessly.
                            </li>
                            <li>
                              <strong>Client Interaction:</strong> Clients can
                              browse portfolios, interact, and hire
                              professionals directly through the app.
                            </li>
                            <li>
                              <strong>Real-Time Updates:</strong> Users receive
                              notifications for new job opportunities and
                              updates.
                            </li>
                            <li>
                              <strong>Search & Filters:</strong> Easy search
                              options to find models or photographers based on
                              specific criteria.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#000" }}> Technologies Used:</h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Mobile App Development: </strong>{" "}
                              <span className="tech">
                                {" "}
                                Native Android (Kotlin) & iOS (Swift)
                              </span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Backend Services:</strong>{" "}
                              <span className="tech"> Node.js and MongoDB</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl15.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_15.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl155.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#09c2c1" }}>
                            Codeflix Staff Monitor : Custom HR & Sales
                            Management Application
                          </h2>
                          <p>
                            As part of our own brand, we developed an advanced
                            HR management, sales management, and order system
                            management application that has become an essential
                            tool for numerous companies. This integrated
                            solution streamlines business operations, providing
                            seamless management of employee data, sales
                            tracking, and order processing.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#09c2c1" }}>
                            Our Contributions:
                          </h3>
                          <ul>
                            <li>
                              <strong>HR Management:</strong> Efficient employee
                              data management, payroll, attendance tracking, and
                              performance monitoring.
                            </li>
                            <li>
                              <strong>Sales Management:</strong> Easy tracking
                              of sales, customer data, and performance metrics
                              to boost productivity.
                            </li>
                            <li>
                              <strong>Order System Management:</strong> Seamless
                              order processing, tracking, and inventory
                              management to ensure smooth business operations.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#09c2c1" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Admin Panel:</strong>{" "}
                              <span className="tech"> PHP, Laravel</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> Android App:</strong>{" "}
                              <span className="tech"> Kotlin</span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> iOS App:</strong>{" "}
                              <span className="tech">Swift</span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
              <Tabs
                className="portfolio_slider"
                onSelect={(index) => console.log(index)}
              >
                <TabList className="horizontal_slide1">
                  <Tab className="div_slide_icon" data-slide="1">
                    <img src="./assets/images/portfolio/fl16.png" alt="" />
                  </Tab>
                </TabList>

                <div className="port_slide">
                  <TabPanel className="port_slide_icon active" data-index="1">
                    <div className="desktop ">
                      <img src="./assets/images/portfolio/f_16.png" alt="" />
                    </div>
                    <div className="detail">
                      <div className="logo_icon">
                        <img src="./assets/images/portfolio/fl166.png" alt="" />
                      </div>
                      <div className="container">
                        <div className="anbr-header">
                          <h2 style={{ color: "#004cd5" }}>
                            Arabian Gulf Perl - A Leading Name in the Oil
                            Industry
                          </h2>
                          <p>
                            Arabian Gulf Perl is one of the most renowned and
                            respected oil companies based in Kuwait, recognized
                            globally for its contributions to the energy sector.
                            We had the privilege of working with this
                            prestigious company to enhance their online presence
                            by designing and developing their official website,
                            along with providing ongoing SEO services for a
                            year.
                          </p>
                        </div>
                        <div className="contributions">
                          <h3 style={{ color: "#004cd5" }}>Key Features:</h3>
                          <ul>
                            <li>
                              <strong>Website Design & Development:</strong>{" "}
                              Crafted a dynamic, user-friendly, and responsive
                              website that reflects the company’s global stature
                              and professionalism.
                            </li>
                            <li>
                              <strong>SEO Services:</strong> Provided
                              comprehensive SEO services to boost the website’s
                              visibility and search engine rankings, ensuring
                              maximum online reach.
                            </li>
                          </ul>
                        </div>
                        <div className="technologies">
                          <h3 style={{ color: "#004cd5" }}>
                            {" "}
                            Technologies Used:
                          </h3>
                          <ul className="tech-list">
                            <li className="tech-item">
                              {" "}
                              <strong> Website Development:</strong>{" "}
                              <span className="tech">
                                {" "}
                                WordPress, HTML, CSS, JavaScript
                              </span>{" "}
                            </li>
                            <li className="tech-item">
                              {" "}
                              <strong> SEO:</strong>{" "}
                              <span className="tech">
                                {" "}
                                On-page and off-page optimization, keyword
                                analysis, content strategy
                              </span>{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};
export default OurWorkDetail;
